import axios from "axios";
import { useSelector } from "react-redux";
const token = "ss";
const api = axios.create({
  // baseURL: 'https://apitest.onlinebar.app/api/v1/',
  // baseURL:'http://127.0.0.1:8000/api/v1/',
  baseURL: "https://api.onlinebar.app/api/v1/",

  headers: {
    "Content-Type": "application/json",
    "X-Client-Version": 8,
  },
});

// api.defaults.withCredentials = true;

export default api;
export const BaseUrl = "https://api.onlinebar.app/api/v1/";
export const NewBaseUrl = "https://api.onlinebar.app/api/v2/";
